<script>
import Dialog from 'primevue/dialog';
import { useSlots, useAttrs, h } from 'vue';

export default {
  setup() {
    const slots = useSlots();
    const attrs = useAttrs();

    return () =>
      h(
        Dialog,
        {
          draggable: false,
          modal: true,
          dismissableMask: true,
          class:
            'col-span-8 col-start-3 md:col-span-6 md:col-start-2 sm:col-span-4 sm:col-start-1',
          ...attrs,
        },
        slots,
      );
  },
};
</script>
